import axios from "axios";
import {
  GetGraphDataRequestBody,
  GetGraphDataPeriodConsumptionsRequestResponse,
  GetGraphDataComparativeConsumptionsRequestResponse,
  GetConsumptionsFileRequestBody,
  HourConsumption,
  DownloadConsumtionsAsync,
} from "../../models/consumptions/consumptions.model";
import {
  base64ToBlob,
  saveFileToAccessibleLocation,
} from "../../../utils/components/consumptions/consumptions.util";
import { CustomWindow } from "../../../core/models/consumptions/consumptions.model";
import { API_ENDPOINTS } from "../../../config/endpoints.config";
const customWindow = window as unknown as CustomWindow;
declare var cordova: any;

const getGraphDataPeriodConsumptions = async (
  getGraphDataRequestBody: GetGraphDataRequestBody,
  token: string,
): Promise<GetGraphDataPeriodConsumptionsRequestResponse> =>
  await axios
    .post(API_ENDPOINTS.CLIENT_SUMMARY_CONSUMPTION, getGraphDataRequestBody, {
      headers: {
        Authorization: token,
      },
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

const getGraphDataHourlyConsumptions = async (
  getGraphDataRequestBody: GetGraphDataRequestBody,
  token: string,
): Promise<HourConsumption[]> =>
  await axios
    .post(API_ENDPOINTS.CLIENT_SUMMARY_CONSUMPTION, getGraphDataRequestBody, {
      headers: {
        Authorization: token,
      },
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

const getGraphDataComparativeConsumptions = async (
  getGraphDataRequestBody: GetGraphDataRequestBody,
  token: string,
): Promise<GetGraphDataComparativeConsumptionsRequestResponse[]> =>
  await axios
    .post(
      API_ENDPOINTS.CLIENT_SUMMARY_CONSUMPTION_COMPARATIVE,
      getGraphDataRequestBody,
      {
        headers: {
          Authorization: token,
        },
      },
    )
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

const getConsumptionsFile = async (
  getConsumptionsFileRequestBody: GetConsumptionsFileRequestBody,
  token: string,
  onFileSaveSuccess: () => void,
): Promise<void> => {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const {
    documentData: { documentContent },
    documentMetadata: { mimeType, name },
  } = await axios
    .post(
      API_ENDPOINTS.CLIENT_CONSUMPTION_DOWNLOAD,
      getConsumptionsFileRequestBody,
      {
        headers: {
          Authorization: token,
        },
      },
    )
    .then(({ data }) => data)
    .catch((error) => {
      console.log("error", error);
      throw error;
    });

  try {
    const trimmedMimeType = mimeType.trim();
    if (isMobile && typeof cordova !== "undefined") {
      if (isIOS) {
        //iOs
        customWindow.PreviewAnyFile?.previewBase64(
          (win: any) => console.log("open status", win),
          (error: any) => console.log("open failed", error.message),
          `data:${trimmedMimeType};base64,${documentContent}`,
        );
      } else {
        //Android
        const blob = base64ToBlob(documentContent, trimmedMimeType);
        customWindow.resolveLocalFileSystemURL(
          cordova.file.dataDirectory,
          (dirEntry: any) => {
            dirEntry.getFile(
              name,
              { create: true, exclusive: false },
              (fileEntry: any) => {
                fileEntry.createWriter(
                  (fileWriter: any) => {
                    fileWriter.onwriteend = () => {
                      console.log('Write of file "' + name + '" completed.');

                      // Open or handle the file here, inside the onwriteend callback
                      cordova.plugins.fileOpener2.open(
                        cordova.file.dataDirectory + name, // File path
                        trimmedMimeType, // Mime type
                        {
                          error: function (e: {
                            status: string;
                            message: string;
                          }) {
                            console.log(
                              "Error status: " +
                                e.status +
                                " - Error message: " +
                                e.message,
                            );
                            // Fallback to save to Downloads or another accessible location
                            saveFileToAccessibleLocation(
                              name,
                              onFileSaveSuccess,
                            );
                          },
                          success: function () {
                            console.log("File opened successfully");
                          },
                        },
                      );
                    };

                    fileWriter.onerror = (e: any) => {
                      console.error(
                        "Write failed:",
                        JSON.stringify(e, null, 2),
                      );
                    };

                    // Write to the file here
                    fileWriter.write(blob);
                  },
                  (error: any) => {
                    console.error(
                      "FileWriter error:",
                      JSON.stringify(error, null, 2),
                    );
                  },
                );
              },
              (error: any) => {
                console.error("getFile error:", JSON.stringify(error, null, 2));
              },
            );
          },
          (error: any) => {
            console.error(
              "resolveLocalFileSystemURL error:",
              JSON.stringify(error, null, 2),
            );
          },
        );
      }
    } else {
      const url = `data:${mimeType};base64,${documentContent}`;
      const link = document.createElement("a");
      if (link.download !== undefined) {
        link.setAttribute("href", url);
        link.setAttribute("download", `${name}`);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
};

const downloadConsumtionsAsync = async (
  requestBody: DownloadConsumtionsAsync,
  token: string,
  abortSignal: AbortSignal,
): Promise<string> =>
  await axios
    .post(API_ENDPOINTS.DOWNLOADS_SEND_MESSAGE, requestBody, {
      headers: {
        Authorization: token,
      },
      signal: abortSignal,
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

export {
  downloadConsumtionsAsync,
  getGraphDataPeriodConsumptions,
  getGraphDataComparativeConsumptions,
  getConsumptionsFile,
  getGraphDataHourlyConsumptions,
};
